import { render, staticRenderFns } from "./edit-notice.vue?vue&type=template&id=d34773d6&scoped=true&"
import script from "./edit-notice.vue?vue&type=script&lang=js&"
export * from "./edit-notice.vue?vue&type=script&lang=js&"
import style0 from "./edit-notice.vue?vue&type=style&index=0&id=d34773d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34773d6",
  null
  
)

export default component.exports